export const CASTING_CONFIG = {
  marketplace: false,
  universalJob: false,
  skillsLimitations: false,
  knockoutQuestions: false,
  bindingJobs: false,
  askForCV: false,
  highContrast: false
};
